import { IDBPDatabase } from 'idb'

import asyncForEach from 'utils/asyncForEach'

import { IDBSchema } from '../types'

/**
 * CHANGES:
 *
 * - Fix store index keyPaths (should be [id, projectId, createdAt]) instead of [createdAt]
 */

export default (
  database: IDBPDatabase<IDBSchema>,
  transaction: IDBTransaction,
  next: () => void
) => {
  STUDIO_ENV_DEVELOPMENT && console.log('---Running migration for v12---')

  const projectStore = transaction.objectStore('projects')
  projectStore.deleteIndex('createdAt')
  projectStore.createIndex('createdAt', ['id', 'createdAt'])
  projectStore.deleteIndex('updatedAt')
  projectStore.createIndex('updatedAt', ['id', 'updatedAt'])

  const actionStore = transaction.objectStore('actions')
  actionStore.deleteIndex('createdAt')
  actionStore.createIndex('createdAt', ['id', 'projectId', 'createdAt'])
  actionStore.deleteIndex('updatedAt')
  actionStore.createIndex('updatedAt', ['id', 'projectId', 'updatedAt'])

  const scriptStore = transaction.objectStore('scripts')
  scriptStore.deleteIndex('createdAt')
  scriptStore.createIndex('createdAt', ['id', 'projectId', 'createdAt'])
  scriptStore.deleteIndex('updatedAt')
  scriptStore.createIndex('updatedAt', ['id', 'projectId', 'updatedAt'])

  const sessionStore = transaction.objectStore('sessions')
  sessionStore.deleteIndex('createdAt')
  sessionStore.createIndex('createdAt', ['id', 'projectId', 'createdAt'])
  sessionStore.deleteIndex('updatedAt')
  sessionStore.createIndex('updatedAt', ['id', 'projectId', 'updatedAt'])

  const tabStore = transaction.objectStore('tabs')
  tabStore.deleteIndex('createdAt')
  tabStore.createIndex('createdAt', ['id', 'projectId', 'createdAt'])
  tabStore.deleteIndex('updatedAt')
  tabStore.createIndex('updatedAt', ['id', 'projectId', 'updatedAt'])

  STUDIO_ENV_DEVELOPMENT && console.log('---Migrated to v12---')
  return next()
}
